import { AppContextProps } from '../../../libs/app-core/AppContext';
import { Member } from '../../dao/Member';
import { MemberDAO } from '../../dao/MemberDAO';
import { UniAnswerDAO } from '../../dao/UniAnswerDAO';
import { UniForm } from '../../dao/UniForm';
import { new_ErrorAlert } from '../../export_spwk/ExportManager';
import { MessageDialog } from '../../../libs/app-core/dialogs/MessageDialog';

export class CommonFormManager {

  /**
   *  對指定受檢者 開單 指定最新版的 Form
   *  sel_member_list: 選擇的受檢者列表
   *  sel_curr_common_forms: 選擇 "最新版" 的 forms
   */
  static async 批次新增一般問卷_KYLe(sel_member_list: Member[], sel_curr_common_forms: UniForm[], ctx: AppContextProps, is_覆蓋基本資料: boolean) {

    let error_messages: string[] = [];

    //#region Valid
    let not_curr_forms = sel_curr_common_forms.filter(x => x.is_curr === 0);
    if (not_curr_forms.length !== 0) {
      throw new_ErrorAlert("456864 必須都是 curr=1");
    }
    //#endregion

    let sel_curr_func_guids = sel_curr_common_forms.map(x => x.func_guid);

    console.log("sel_curr_func_guids", sel_curr_func_guids);

    for (const sel_member of sel_member_list) {
      try {
        if (error_messages.length >= 5) {
          error_messages.push("發現5筆錯誤，強制停止");
          alert("發現5筆錯誤，強制停止!");
          break;
        }

        await MemberDAO.Update_更新受檢者一般問卷的Guids(sel_member, sel_curr_func_guids);

        await UniAnswerDAO.Save_新增或更新一般問卷Answers(sel_member, sel_curr_common_forms, is_覆蓋基本資料);

      } catch (ex: any) {
        let err = sel_member.member_code + " " + sel_member.member_name + " 發生錯誤:" + ex.message;
        console.log(err);

        error_messages.push(err);
      }

    }


    if (error_messages.length !== 0) {
      alert("TODO 有錯誤 x" + error_messages.length);
      console.log("error_messages", error_messages);
    } else {
      MessageDialog.Show(ctx, "設定成功!");
    }
  }
}

